import { toast } from 'react-toastify'

// default is to display toast messages for both success and error
export const ToastAll = {
  successMessage: true,
  errorMessage:   true,
}

// - this is the quieter option
export const ToastErrors = {
  successMessage: false,
  errorMessage:   true,
}

// - this is the other quieter option
export const ToastSuccess = {
  successMessage: true,
  errorMessage:   false,
}

// - this is the silent option
export const ToastNone = {
  successMessage: false,
  errorMessage:   false,
}

export const toaster = (json, options = ToastAll) => {
  if (json.ok) {
    if (json.message && options.successMessage) {
      toast.success(json.message)
    }
  }
  else {
    if (json.message && options.errorMessage) {
      toast.error(json.message)
    }
  }
  return json
}

